import { Redirect, Route } from "react-router-dom";
import { getBearer } from "utils/userStorage";
import { getPractice } from "./practiceStorage";

export default function PrivateRoute({
  component: Component,
  needsPractice = false,
  ...rest
}) {
  const bearer = getBearer();
  const practice = getPractice();

  // some pages require a practice

  if (needsPractice) {
    return (
      <Route
        {...rest}
        render={props =>
          bearer && practice ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/practice",
                state: { from: props.location },
              }}
            />
          )
        }
      />
    );
  }

  // practice page and admin pages do not require a practice!
  return (
    <Route
      {...rest}
      render={props =>
        bearer ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}
